
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M9.5 8C8.672 8 8 8.586 8 9.31v26.38c0 .724.672 1.31 1.5 1.31s1.5-.586 1.5-1.31V9.31C11 8.586 10.328 8 9.5 8zM14.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C16 8.603 15.328 8 14.5 8zM19.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C21 8.603 20.328 8 19.5 8zM39.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C41 8.603 40.328 8 39.5 8zM29.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C31 8.603 30.328 8 29.5 8zM34.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C36 8.603 35.328 8 34.5 8zM25.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C27 8.603 26.328 8 25.5 8zM46.5 8c-.828 0-1.5.603-1.5 1.348v20.304c0 .745.672 1.348 1.5 1.348s1.5-.603 1.5-1.348V9.348C48 8.603 47.328 8 46.5 8zM52.5 8c-.828 0-1.5.586-1.5 1.31v26.38c0 .724.672 1.31 1.5 1.31s1.5-.586 1.5-1.31V9.31C54 8.586 53.328 8 52.5 8z"}}),_c('path',{attrs:{"d":"M58.024 0H3.975A3.975 3.975 0 000 3.966v38.068A3.976 3.976 0 003.975 46h54.05A3.976 3.976 0 0062 42.034V3.966A3.976 3.976 0 0058.024 0zm1.3 42.034c0 .714-.583 1.295-1.3 1.295H3.975a1.299 1.299 0 01-1.298-1.295V3.966c0-.714.582-1.295 1.298-1.295h54.05c.716 0 1.298.581 1.298 1.295v38.068z"}})])])
          )
        }
      }
    